import { ISilderName, ItemRoutesProps } from "./PageRoute";
import { Route } from "react-router-dom";
import { findUserPremission } from "../../Pages/Users/Roles/UserSecurityFind";
import SalesInvoiceTemplate from "../../Template/SalesInvoiceTemplate";
import PartyNestedRoute from "../../Pages/Master/PartyNestedRoute";
import ResourceNotFound from "../ResourceNotFound";
import DashboardTemplate from "../../Template/DashboardTemplate";
import GroupDetails from "../../Pages/Master/Group/AllDetailsGroupWise/GroupDetails";
import { SearchLedgerByGroupsTypes } from "../../Services/LedgerService";
import LedgerDetails from "../../Pages/Master/Ledger/LedgerDetails";

const PartiesRoute = ({
  currentClient,
  clientSpecificRole,
}: ItemRoutesProps) => {
  return (
    <>
      {/*  ----- Parties Route -----*/}
      <Route
        key="party"
        path={`/${currentClient?.id}/party/*`}
        // path={"sales/*"}
        element={
          // <AsyncSalesInvoiceTemplate
          findUserPremission(
            ["Master.Ledger.Party.View", "Master.Group.Party.View"],
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <SalesInvoiceTemplate
              // element={<AsyncSalesNestedRoute />}
              element={<PartyNestedRoute />}
              silderName={ISilderName.Party}
              breadcrumprops={[
                {
                  item: "Party",
                  path: `/billing/clients/${currentClient?.id}/party/parties`,
                },
              ]}
              menuprops={[
                {
                  showData: "Parties",
                },
                {
                  showData: "Parties Group",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      {/* Party Inside Details Routes */}
      <Route
        path={`/${currentClient?.id}/party/partyLedger/:ledgerId`}
        element={
          <DashboardTemplate
            element={
              <LedgerDetails
                searchLedgerByGroupsTypes={
                  SearchLedgerByGroupsTypes.PartiesOnly
                }
                showName="Party Name"
              />
            }
            breadcrumprops={[
              {
                item: "Party",
                path: `/billing/clients/${currentClient?.id}/party/parties`,
              },
              {
                item: "PartyLedger",
              },
            ]}
          />
        }
      />
      <Route
        path={`/${currentClient?.id}/party/partiesGroup/:groupId`}
        element={
          <DashboardTemplate
            element={
              <GroupDetails
                searchLedgerByGroupsTypes={
                  SearchLedgerByGroupsTypes.PartiesOnly
                }
                showName="Party"
              />
            }
            breadcrumprops={[
              {
                item: "Party Group",
                path: `/billing/clients/${currentClient?.id}/party/partiesGroup`,
              },
              {
                item: "Details",
              },
            ]}
          />
        }
      />
    </>
  );
};

export default PartiesRoute;
